<template>
  <div id="header" :class="scroll > 80 ? '_is_top' : ''">
    <!-- <div id="header"> -->
    <div class="_center" v-if="$store.state.screenWidth > 960">
      <div class="_left">
        <div class="_logo" @click="$router.push('/')">
          <img :src="scroll > 80 ? '/static/img/模数logo彩色.png' : '/static/img/模数logo白色.png'" alt="">
        </div>
      </div>
      <div class="_right">
        <ul class="_nav">
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'Index' ? '_active' : ''
            "
          >
            <router-link to="/">首页</router-link>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'About' ? '_active' : ''
            "
          >
            <router-link to="/about">关于模数</router-link>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'Lvp' ? '_active' : ''
            "
          >
            <router-link to="/product/lvp">产品中心</router-link>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'ProjectShow'
                ? '_active'
                : ''
            "
          >
            <router-link to="/project">解决方案</router-link>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'News' ? '_active' : ''
            "
          >
            <a href="/news_center.html">新闻动态</a>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'Contact'
                ? '_active'
                : ''
            "
          >
            <router-link to="/contact">联系我们</router-link>
          </li>
        </ul>
        <div class="_phone" hidden>
          <!-- 400-0098-709 -->
          <!-- <i class="iconfont icon-dianhua1" style="margin-right: 5px"></i> -->
        </div>
      </div>
    </div>
    <div class="_mobile" v-else-if="$store.state.screenWidth <= 960">
      <van-nav-bar
        right-text="按钮"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      >
        <template #left>
          <div class="_m_icon"></div>
        </template>
        <template #right>
          <i class="_icon iconfont icon-shouqianniuicon"></i>
        </template>
        <template #title>
          <!-- <div style="color: #333; font-weight: bold" hidden>
            <i class="iconfont icon-dianhua1"></i>
            <a style="color: #333" href="tel:400-0098-709">400-0098-709</a>
          </div> -->
        </template>
      </van-nav-bar>
      <van-popup v-model="mobile.show" round position="top">
        <!-- <van-cell title="首页" /> -->
        <van-nav-bar
          right-text="按钮"
          left-arrow
          @click-left="onClickLeft"
          @click-right="onClickRightClose"
        >
          <template #left>
            <div class="_m_icon" hidden></div>
          </template>
          <template #right>
            <i class="_icon iconfont icon-guanbi"></i>
          </template>
          <template #title>
            <!-- <div style="color: #333; font-weight: bold">
              <i class="iconfont icon-dianhua1"></i>
              <a style="color: #333" href="tel:400-0098-709">400-0098-709</a>
            </div> -->
          </template>
        </van-nav-bar>
        <van-collapse v-model="mobile.activeName" accordion class="_mobile_menu">
          <van-cell
            title="首页"
            to="/"
            :class="$store.state.headNav === 'Index' ? '_active' : ''"
          ></van-cell>
          <van-cell
            title="关于模数"
            to="/about"
            :class="$store.state.headNav === 'About' ? '_active' : ''"
          ></van-cell>
          <van-collapse-item name="3">
            <template #title>
              <div style="color: #666">
                <i
                  class="_icon iconfont icon-chanpinguanli"
                  style="margin-right: 0.2rem"
                ></i
                >产品中心
              </div>
            </template>
            <van-cell
              to="/product/lvp"
              :class="$store.state.newsNav === 'Lvp' ? '_active' : ''"
              title="智慧后勤"
            />
            <van-cell
              :class="$store.state.newsNav === 'Opm' ? '_active' : ''"
              to="/product/opm"
              title="智慧节能"
            />
          </van-collapse-item>
          <van-cell
            title="解决方案"
            to="/project"
            :class="$store.state.headNav === 'ProjectShow' ? '_active' : ''"
          ></van-cell>
          <van-cell
            title="新闻动态"
            url="/news_center.html"
            :class="$store.state.headNav === 'News' ? '_active' : ''"
          ></van-cell>
          <van-collapse-item name="5">
            <template #title>
              <div style="color: #666">
                <i
                  class="_icon iconfont icon-dianhua1"
                  style="margin-right: 0.2rem"
                ></i
                >联系我们
              </div>
            </template>
            <van-cell
              to="/contact"
              title="合作伙伴"
              :class="$store.state.contactNav === 'Contact' ? '_active' : ''"
            />
            <van-cell
              to="/contact/relation"
              title="联系我们"
              :class="$store.state.contactNav === 'Relation' ? '_active' : ''"
            />
          </van-collapse-item>
        </van-collapse>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scroll: 0,
      flag: false,
      scrollTop: "",
      mobile: {
        show: false,
        activeName: "1",
      },
      activeNav: "",
    };
  },
  // 滚动监听
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
    this.scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.init();
  },
  methods: {
    init() {
      if (
        this.$store.state.aboutNav === "About" ||
        this.$store.state.aboutNav === "Honor"
      ) {
        this.mobile.activeName = "2";
      } else if (
        this.$store.state.newsNav === "News" ||
        this.$store.state.newsNav === "Industry"
      ) {
        this.mobile.activeName = "3";
      } else if (
        this.$store.state.contactNav === "Contact" ||
        this.$store.state.contactNav === "Relation" ||
        this.$store.state.contactNav === "JoinUs"
      ) {
        this.mobile.activeName = "5";
      }
    },
    // 获取页面滚动距离
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scroll = scrollTop;
    },
    onClickLeft() {
      this.$router.push({
        name: "Index",
      });
    },
    onClickRight() {
      this.mobile.show = true;
    },
    onClickRightClose() {
      this.mobile.show = false;
    },
  },
  // 滚动重置
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
#header {
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  color: #fff;
  transition: background 0.5s ease 0s;
  display: flex;
  overflow: hidden;

  &._is_top {
    background: #fff;
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    z-index: 999;
    ._item {
      a {
        color: #333 !important;
        text-shadow: none;
      }
      &:hover a,
      &._active a {
        color: #2b81ff !important;
      }
    }
  }
  ._center {
    width: 100%;
    max-width: 12rem;
    height: 0.7rem;
    margin: 0 auto;
    padding: 0 0.2rem;
    display: flex;
    justify-content: space-between;
    ._left {
      height: 100%;
      display: flex;
      align-items: center;
      ._logo {
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          display: block;
          width: auto;
          height: 70%;
          max-width: 1.6rem;
          object-fit: contain;
        }
      }
    }
    ._right {
      position: relative;
      ._nav {
        display: flex;
        ._item {
          line-height: 0.7rem;
          padding: 0 0.3rem;
          font-size: 0.18rem;
          cursor: pointer;
          a {
            color: #fff;
            text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
            text-decoration: none;
            transition: color 0.3s;
          }
          &:hover a,
          &._active a {
            color: #a8d0ff;
          }
          &._active a {
            font-weight: bold;
          }
        }
      }

      ._phone {
        position: absolute;
        top: 0;
        right: -2rem;
        width: 1.9rem;
        height: 0.48rem;
        line-height: 0.48rem;
        text-align: center;
        font-weight: bold;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/right_tel.png")
          no-repeat;
        // background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
        //   linear-gradient(#000000, #000000);
        // background-blend-mode: normal, normal;
        background-size: cover;
        border-radius: 0rem 0rem 0.1rem 0.1rem;
        text-shadow: 0rem 0.01rem 0.01rem;
        font-size: 0.18rem;
        i {
          font-size: 0.18rem;
        }
        color: #fff;
      }
    }
  }
  ._mobile {
    width: 100%;
    height: $header-offset;
    // /deep/ .van-overlay {
    //   background-color: transparent !important;
    // }
    .van-nav-bar {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      ._m_icon {
        width: 0.6rem;
        height: 0.3rem;
        background: url('/static/img/模数logo彩色.png') no-repeat;
        background-size: contain;
        background-position: center;
      }
      ._icon {
        font-size: 0.2rem;
        color: #666;
      }
    }
    ._active {
      color: #3660aa !important;
    }
    ._mobile_menu {
      padding: 0.1rem 0;
    }
    .van-cell {
      color: #666;
    }
    ._icon {
      color: #666;
    }
    .van-cell__title {
      padding-left: 0.2rem;
    }
    .van-popup--top {
      top: $header-offset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue